<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" :size="mobileVersion ? 'fs' : 'lg-fix-h'" :ariaLabel="$t('app.help_dialog_title')">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{$t('app.help_dialog_title')}}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
       <el-tabs tab-position="left" class="pt-2" style="height: inherit" ref="containertabs" v-model="tabSelected">
        <el-tab-pane class="p-2 overflow-y-auto container-youtube" name="academy"
          :style="mobileVersion ? 'height: 80vh;' : 'height: 52vh;'"
        >
          <span slot="label" class="flex items-center justify-start">
            <base-icon name="videos" size="xsm" class="mr-1"/> 
            <span v-if="!mobileVersion">{{$t('academy.title')}}</span>
            <span v-else>&nbsp;</span>
          </span>
          <div class="block xl:grid xl:grid-cols-5 gap-x-2">
            <div class="mt-8 xl:col-span-2 pr-4 pl-4">
              <h3 class="font-bold text-lg mb-4">
                {{$t('academy.title')}}
              </h3>
              <p class="mt-4 text-balance">
                {{$t('academy.desc_1')}} <span class="font-bold">{{$t('academy.desc_2')}}</span>
              </p>
              <p class="mt-6">
                <base-button 
                  mode="primary" 
                  :text="$t('academy.button')" 
                  @click="goToAcademy" />
              </p>
            </div>
            <div class="hidden xl:block xl:col-span-3">
              <base-logo
                filename="academy.png"
                :alt="$t('academy.title')"
                :title="$t('academy.title')"
                class="brand rounded-md"
              />
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane class="p-2 overflow-y-auto" name="manuales"
          :style="mobileVersion ? 'height: 80vh;' : 'height: 52vh;'"
          >
          <span slot="label" class="flex items-center justify-start">
            <base-icon name="manual" size="xsm" class="mr-1"/> 
            <span v-if="!mobileVersion">{{$t('app.use_manual')}}</span>
              <span v-else>&nbsp;</span>
          </span>
          <div>
            <h3 class="font-medium text-lg mb-2">
              {{$t('app.user_manual')}}
            </h3>
            <div class="flex mb-2 items-center">
              <div class="w-full">
                <i18n path="app.user_manual_long" tag="p">
                  <span class="text-primary cursor-pointer hover:bg-primary-100 dark:hover:bg-darkblue-600 rounded" @click="openManualUsuario">{{$t('app.here')}}</span>
                </i18n>
              </div>
              <base-button-icon
                @click="downloadManualUsuario"
                size="xs"
                name="download"
                class="bg-primary-100 dark:bg-darkblue-800 dark:text-darkblue-200 rounded-full ml-2 mr-4"
              />
            </div>
          </div>

          <div v-if="role === 3 || role === 8 || role === 7">
            <h3 class="font-medium text-lg mb-2">
              {{$t('app.distributor_manual')}}
            </h3>
            <div class="flex mb-2 items-center">
              <div class="w-full">
                <i18n path="app.distributor_manual_long" tag="p">
                  <span class="text-primary cursor-pointer hover:bg-primary-100 dark:hover:bg-darkblue-600 rounded" @click="openManualDistribuidor">{{$t('app.here')}}</span>
                </i18n>
              </div>
              <base-button-icon
                @click="downloadManualDistribuidor"
                size="xs"
                name="download"
                class="bg-primary-100 dark:bg-darkblue-800 dark:text-darkblue-200 rounded-full ml-2 mr-4"
              />
            </div>
          </div>

          <a href="/files/EdasInvoiZE-Manual-v7.5.pdf" download class="hidden" ref="downloadManualBtn"/>
          <a href="/files/EdasInvoiZE-Manual-Distribuidor-v6.0.pdf" download class="hidden" ref="downloadManualDistribuidorBtn"/>
        </el-tab-pane>
        <el-tab-pane class="p-2 overflow-y-auto" name="patch-notes"
          :style="mobileVersion ? 'height: 80vh;' : 'height: 52vh;'"
        >
          <span slot="label" class="flex items-center justify-start">
            <base-icon name="notes" size="xsm" class="mr-1"/> 
            <span v-if="!mobileVersion">{{$t('app.version_notes')}}</span>
            <span v-else>&nbsp;</span>
          </span>
          <div v-for="(version, index) in dataPatchNotes" :key="version.title" class="mb-8">
            <h3 class="font-medium text-lg mb-2">
              {{ version.title }} <span v-if="index === 0"> - {{$t('app.current_version')}}</span>
            </h3>
            <p class="italic mb-2">
              {{ $d(Date.parse(version.date), 'long_date') }}
            </p>
            <div v-for="cambio in version.changes" :key="cambio.title" class="mb-4">
              <p class="font-medium mb-2">
                {{ cambio.title }}
              </p>
              <div v-for="descripcion in cambio.description" :key="descripcion">
                <p v-if="containsLinkTag(descripcion)" v-safe-html="computeTag(descripcion,cambio.links)">
                </p>
                <p v-else>
                  • {{ descripcion }}
                </p>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <!-- <el-tab-pane :disabled="!this.videoIds || this.videoIds.length === 0" class="p-2 overflow-y-auto container-youtube"
          :style="mobileVersion ? 'height: 80vh;' : 'height: 52vh;'"
        >
          <span slot="label" class="flex items-center justify-start">
            <base-icon name="videos" size="xsm" class="mr-1"/> 
            <span v-if="!mobileVersion">{{$t('app.explainer_videos')}}</span>
              <span v-else>&nbsp;</span>
          </span>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
            <div v-for="video in videoIds" :key="video.id">
              <p class="font-medium text-lg mb-2 truncate">
                {{ video.Titulo }}
              </p>
              <youtube :video-id="video.IdLink" ref="youtube" class="h-60 md:h-40 lg:h-60"/>
            </div>
          </div>
        </el-tab-pane> -->
        <el-tab-pane class="p-2 overflow-y-auto" name="declaracion-responsable"
          :style="mobileVersion ? 'height: 80vh;' : 'height: 52vh;'"
          >
          <span slot="label" class="flex items-center justify-start">
            <base-icon name="manual" size="xsm" class="mr-1"/> 
            <span v-if="!mobileVersion">{{$t('app.responsible_declaration')}}</span>
            <span v-else>&nbsp;</span>
          </span>
          <div>
            <h3 class="font-medium text-lg mb-2">
              {{$t('app.responsible_declaration_of')}}
            </h3>
            <div class="flex mb-2 items-center">
              <div class="w-full">
                <i18n path="app.responsible_declaration_long" tag="p">
                  <span class="text-primary cursor-pointer hover:bg-primary-100 dark:hover:bg-darkblue-600 rounded" @click="openResponsibleDeclaration">{{$t('app.here')}}</span>
                </i18n>
              </div>
              <base-button-icon
                @click="downloadResponsibleDeclaration"
                size="xs"
                name="download"
                class="bg-primary-100 dark:bg-darkblue-800 dark:text-darkblue-200 rounded-full ml-2 mr-4"
              />
            </div>
          </div>

          <a href="/files/DECLARACION_RESPONSABLE_DEL_SISTEMA_INFORMATICO_DE_FACTURACION.pdf" download class="hidden" ref="downloadResponsibleDeclarationBtn"/>
        </el-tab-pane>
        <el-tab-pane class="p-2 overflow-y-auto" name="licencia-uso"
          :style="mobileVersion ? 'height: 80vh;' : 'height: 52vh;'"
        >
          <span slot="label" class="flex items-center justify-start">
            <base-icon name="contract" size="xsm" class="mr-1"/> 
            <span v-if="!mobileVersion">{{$t('app.use_license')}}</span>
              <span v-else>&nbsp;</span>
          </span>
          <h3 class="font-bold text-lg mb-4">
            {{$t('app.license_dialog_title')}}
          </h3>
          <LicenseContent/>
        </el-tab-pane>
        <el-tab-pane class="p-2 overflow-y-auto" name="accesibilidad"
          :style="mobileVersion ? 'height: 80vh;' : 'height: 52vh;'"
          tabIndex="0"
          >
          <span slot="label" class="flex items-center justify-start">
            <base-icon name="accessible" size="sm" class=""/> 
            <span v-if="!mobileVersion">{{$t('app.accessibility')}}</span>
              <span v-else>&nbsp;</span>
          </span>
          <h3 class="font-bold text-lg mb-6">
            {{$t('app.accessibility_dialog_title')}}
          </h3>
          <AccesibilityContent/>
        </el-tab-pane>
        <el-tab-pane class="p-2 overflow-y-auto" name="contact-backup"
          :style="mobileVersion ? 'height: 80vh;' : 'height: 52vh;'"
        >
          <span slot="label" class="flex items-center justify-start">
            <base-icon name="mail" size="xsm" class="mr-1"/> 
            <span v-if="!mobileVersion">{{$t('app.contact_backup')}}</span>
              <span v-else>&nbsp;</span>
          </span>
          <h3 class="font-bold text-lg mb-4">
            {{$t('app.contact')}}
          </h3>
          <p class="mb-2" v-if="this.urlSoporte">
            <span class="font-medium">{{$t('app.url')}}: </span>
            <span class="text-primary-800 cursor-pointer hover:text-primary-900 hover:bg-primary-100 dark:hover:bg-darkblue-800 rounded" @click="openURLDistribuidor" tabIndex="0">
              {{this.urlSoporte}}
            </span> 
          </p>
          <p class="mb-2" v-if="this.emailSoporte">
            <span class="font-medium">{{$tc('users.email', 1)}}:</span> {{this.emailSoporte}}
          </p>
          <p class="mb-2" v-if="this.telefonoSoporte">
            <span class="font-medium">{{$t('address.telefono')}}:</span> {{this.telefonoSoporte}}
          </p>
          <h3 class="font-bold text-lg mb-4 mt-12">
            {{$t('app.backup')}}
          </h3>
          <p class="mb-2">
            <span class="font-medium">{{$t('app.last_backup_date')}}:</span> {{$d(this.lastBackupDate, 'numeric_datetime', { date: '-', datetime: ' ' })}}
          </p>
        </el-tab-pane>
      </el-tabs>
      <el-form
        ref="ruleForm"
      >
        <div class="lg:mb-2">
        </div>
      </el-form>
    </template>
    <template slot="footer">
      <div class="w-full items-end justify-end flex space-x-2 px-4 bg-white py-2 mt-auto dark:bg-darkblue-900">
        <base-button v-if="btnLicense" @click="downloadLicense" mode="secondary-phantom-blue" :text="$t('app.download')"/>
        <base-button @click="toggleDialog" mode="secondary-phantom-blue" :text="$t('app.close')" />
          <a href="/files/EdasInvoiZE-Licencia-uso.pdf" download class="hidden" ref="downloadLicense"/>
      </div>
    </template>
  </base-dialog-button>
</template>

<script>
import moment from 'moment'
import { i18n } from '@/i18n'
import LicenseContent from '@/components/license/LicenseContent.vue'
import AccesibilityContent from '@/components/license/AccesibilityContent.vue'
import { PATCH_NOTES } from '@/config/dynamic/patch-notes-es'
import { getVideos } from '@/services/config/getVideos.js'

const localesMap = {
  es: () => import(/* webpackChunkName: "patch-notes-es" */ '@/config/dynamic/patch-notes-es'),
  'en-GB': () => import(/* webpackChunkName: "patch-notes-en" */ '@/config/dynamic/patch-notes-en-GB'),
  fr: () => import(/* webpackChunkName: "patch-notes-fr" */ '@/config/dynamic/patch-notes-fr'),
  de: () => import(/* webpackChunkName: "patch-notes-de" */ '@/config/dynamic/patch-notes-de'),
  ca: () => import(/* webpackChunkName: "patch-notes-ca" */ '@/config/dynamic/patch-notes-ca')
}

export default
{
  name: 'help-dialog',
  components: {
    LicenseContent,
    AccesibilityContent,
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    mobileVersion: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    dialogOpen: function (value, oldValue) {
      if (value) {
        this.getVideos()
        setTimeout(() => {
          if (process.env.VUE_APP_AIAPI && process.env.VUE_APP_AIAPI !== 'off') { 
            this.$store.commit('app/setshowButtonChatbot', true)
          }
        }, 1000)
        this.loadPatchNotes()
      } 
    },
    '$i18n.locale' (newLocale, oldLocale) {
      if (newLocale && newLocale !== oldLocale) {
        this.loadPatchNotes(newLocale)
      }
    },
    lastBackupDate: function (value, oldValue) {
      if (value !== oldValue && this.dialogOpen && this.tabSelected === 'contact-backup') {
        const count = value.get('hour') % 12 === 1 ? 1 : 2
        this.doFeedback(i18n.t('feedback.info.last_backup_date_changed', { date: i18n.d(value, 'accesible_datetime', { datetime: ` ${i18n.tc('app.at_time', count)} ` }) }), 'info', undefined, true)
      }
    },
    backupHours: 'restartBackupTimer',
    backupMinutes: 'restartBackupTimer',
    backupSeconds: 'restartBackupTimer'
  },
  data: function () {
    return {
      // Se actualiza a las 11:00,
      // Para cambiar la actualización ver método `this.scheduleNextUpdate`
      // Para cambiar la hora de referencia ver `backupHours`, `backupMinutes`, `backupSeconds`
      now: moment(),
      tabSelected: 'academy',
      isOpen: this.dialogOpen,
      isLoadedData: false,
      // dataPatchNotes: PATCH_NOTES,
      patchNotesLang: '',
      dataPatchNotes: [],
      videoIds: [],
      urlAcademy: 'https://academy.zerocoma.com/',
      backupTimer: null,
      backupHours: 11,
      backupMinutes: 0,
      backupSeconds: 0
    }
  },
  created () {
  },
  mounted () {
    this.scheduleNextUpdate()
  },
  beforeDestroy () {
    clearTimeout(this.backupTimer)
  },
  computed: {
    role: function () {
      return this.$store.getters['auth/role']
    },
    heigthVideos () {
      return this.mobileVersion ? 160 : 240
    },
    user: function () {
      return this.$store.getters['auth/user']
    },
    emailSoporte: function () {
      return this.user?.Contacto?.Email || null
    },
    urlSoporte: function () {
      if (this.user?.Contacto?.URL) {
        const url = this.user.Contacto.URL
        
        // Expresión regular que detecta si la URL empieza con un protocolo
        if (/^[a-zA-Z]+:\/\//.test(url)) {
          return url.trim()  
        }
        // Si no tiene protocolo, agregar https://
        return 'https://' + url.trim()
      }
      return null
    },
    telefonoSoporte: function () {
      return this.user?.Contacto?.Telefono || null
    },
    btnLicense: function () {
      return this.tabSelected === 'licencia-uso'
    },
    lastBackupDate: function () {
      const backupTime = this.now.clone().hours(this.backupHours).minutes(this.backupMinutes).seconds(this.backupSeconds)
      if (this.now.isBefore(backupTime)) {
        return backupTime.subtract(1, 'days')
      }
      return backupTime
    }
  },
  methods: {
    goToAcademy () {
      window.open(this.urlAcademy, '_blank')
    },
    getVideos: async function () {
      try {
        this.isLoadedData = false
        const response = await getVideos()
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          for (let i = 0; i < response.listaVideos.length; i++) {
            response.listaVideos[i].id = i
          }
          this.videoIds = response.listaVideos
          this.isLoadedData = true
        }
      } catch (error) {
        this.doFeedback()
      } 
    },
    toggleDialog: function () {
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
    },
    downloadManualUsuario () {
      this.$refs.downloadManualBtn.click()
    },
    downloadManualDistribuidor () {
      this.$refs.downloadManualDistribuidorBtn.click()
    },
    downloadResponsibleDeclaration () {
      this.$refs.downloadResponsibleDeclarationBtn.click()
    },
    openManualUsuario () {
      window.open(window.location.origin + '/files/EdasInvoiZE-Manual-v7.5.pdf')
    },
    openManualDistribuidor () {
      window.open(window.location.origin + '/files/EdasInvoiZE-Manual-Distribuidor-v6.0.pdf')
    },
    openURLDistribuidor () {
      window.open(this.urlSoporte, '_blank')
    },
    openResponsibleDeclaration () {
      window.open(window.location.origin + '/files/DECLARACION_RESPONSABLE_DEL_SISTEMA_INFORMATICO_DE_FACTURACION.pdf')
    },
    // playVideo () {
    //   this.player.playVideo()
    // },
    downloadLicense () {
      this.$refs.downloadLicense.click()
    },
    containsLinkTag (descripcion) {
      return descripcion.includes('#link:')
    },
    computeTag (descripcion, links) {
      descripcion = `• ${descripcion}`
      const tags = []
      let finalIndex = 0
      let initIndex = descripcion.indexOf('#link:', finalIndex)
      let hasMoreTags = false
      if (initIndex !== -1) {
        do {
          initIndex = descripcion.indexOf('#link:', finalIndex)
          finalIndex = descripcion.indexOf('#', initIndex+1)
          tags.push(descripcion.substring(initIndex, finalIndex+1))
          hasMoreTags = descripcion.indexOf('#link:', finalIndex) !== -1
        } while (hasMoreTags)

        tags.forEach(tag => {
          const searchedLink = links.filter(filter => filter.tag === tag.split(':')[1].replace('#', ''))[0]
          if (searchedLink) {
            const defaultLink = `<a href= "${searchedLink.url}" style="text-decoration: underline" target="_blank">${searchedLink.linkName}</a>`
            descripcion = descripcion.replace(tag, defaultLink)
          }
        })
      }
      return descripcion
    },
    async loadPatchNotes (locale) {
      const currentLocale = locale || this.$i18n.locale || 'es'
      if (this.dialogOpen && this.patchNotesLang !== currentLocale) {
        try {
          const loader = localesMap[currentLocale] || localesMap.es // Fallback al español
          this.dataPatchNotes = (await loader()).PATCH_NOTES
          this.patchNotesLang = currentLocale
        } catch (error) {
          console.error('Error loading patch notes for locale:', currentLocale, error)
          this.dataPatchNotes = PATCH_NOTES
        }
      }
    },
    scheduleNextUpdate () {
      const now = moment()
      const target = now.clone().hours(this.backupHours).minutes(this.backupMinutes).seconds(this.backupSeconds)
    
      // si ya pasó hoy → mañana
      if (now.isSameOrAfter(target)) {
        target.add(1, 'day')
      }

      const msUntilTarget = target.diff(now)
      this.backupTimer = setTimeout(() => {
        this.now = moment()
        this.scheduleNextUpdate() // reprogramar para el siguiente día
      }, msUntilTarget)
    },
    restartBackupTimer () {
      clearTimeout(this.backupTimer)
      this.scheduleNextUpdate()
    }
  }
}
</script>
